<template>
  <div class="infoPage">
        <div class="dialogBox">
          <h1>{{message}}</h1>
          <h2>{{message2}}</h2>
          <p>{{message3}}</p>
        </div>
      </div>
</template>
<script>
export default {
  props: ["message","message2","message3"],
  computed: {
   
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Main/Info.vue